
import { instantiate } from './NewsByLevel-appWeb.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
memory,
_initialize
} = exports


